/**
 * Renders the Wish List page (sections/wishlist-page.liquid) as real
 * product cards. Add to Cart here is ungated — same as everywhere else
 * in the store, anonymous carts work fine and sign-in only happens at
 * checkout.
 *
 * Cards are built with document.createElement/.textContent, never
 * innerHTML — title/price/url/image round-trip through localStorage as
 * plain decoded strings, so inserting them via innerHTML would be an
 * XSS risk if a title ever contained HTML-like characters.
 */
(function () {
  function root() {
    return document.querySelector('[data-wishlist-page]');
  }

  function buildCard(item) {
    var li = document.createElement('li');
    li.className = 'wishlist-page__card';
    li.dataset.wishlistCardId = item.id;

    var mediaWrap = document.createElement('div');
    mediaWrap.className = 'wishlist-page__card-media-wrap';

    var mediaLink = document.createElement('a');
    mediaLink.href = item.url;
    mediaLink.className = 'wishlist-page__card-media';
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      img.loading = 'lazy';
      mediaLink.appendChild(img);
    }

    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'wishlist-page__card-remove';
    removeButton.setAttribute('data-wishlist-remove', item.id);
    removeButton.setAttribute('aria-label', 'Remove from wishlist');
    // Static, theme-controlled markup (not user-influenced) — safe to set directly.
    removeButton.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>';

    mediaWrap.appendChild(mediaLink);
    mediaWrap.appendChild(removeButton);

    var title = document.createElement('a');
    title.href = item.url;
    title.className = 'wishlist-page__card-title';
    title.textContent = item.title;

    var price = document.createElement('span');
    price.className = 'wishlist-page__card-price';
    price.textContent = item.price;

    var addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'wishlist-page__card-add';
    addButton.setAttribute('data-wishlist-add', item.id);
    if (item.variant) addButton.setAttribute('data-variant-id', item.variant);
    addButton.textContent = 'Add to Cart';

    li.appendChild(mediaWrap);
    li.appendChild(title);
    li.appendChild(price);
    li.appendChild(addButton);
    return { li: li, priceEl: price, addButton: addButton };
  }

  function render() {
    var container = root();
    if (!container || !window.Wishlist) return;

    var list = container.querySelector('[data-wishlist-items]');
    var emptyMessage = container.querySelector('[data-wishlist-empty]');
    var items = window.Wishlist.getAll();

    list.textContent = '';

    if (!items.length) {
      list.hidden = true;
      emptyMessage.hidden = false;
      return;
    }

    emptyMessage.hidden = true;
    list.hidden = false;

    items.forEach(function (item) {
      var built = buildCard(item);
      list.appendChild(built.li);
      enrich(item, built);
    });
  }

  // Refresh price/availability from the live product, and resolve a
  // variant id for items wishlisted before variant ids were captured.
  function enrich(item, built) {
    fetch(item.url + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product fetch failed');
        return response.json();
      })
      .then(function (product) {
        var variant =
          (product.variants || []).find(function (v) {
            return String(v.id) === String(item.variant);
          }) || product.variants[0];

        if (!variant) return;

        built.priceEl.textContent = formatMoney(variant.price);

        if (!variant.available) {
          built.priceEl.classList.add('wishlist-page__card-price--sold-out');
          built.addButton.textContent = 'Sold Out';
          built.addButton.disabled = true;
        } else {
          built.addButton.setAttribute('data-variant-id', variant.id);
        }
      })
      .catch(function () {
        // Live product fetch failed (deleted product, network) — the
        // card still shows the stored snapshot, just not refreshed.
      });
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function addToCart(variantId, button) {
    var container = root();
    var cartAddUrl = (container && container.getAttribute('data-cart-add-url')) || '/cart/add';
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
    };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(cartAddUrl, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || 'Add to cart failed');
        button.textContent = 'Added';
        if (cart) cart.renderContents(response);
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      })
      .catch(function () {
        button.textContent = 'Error';
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      });
  }

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton && window.Wishlist) {
      window.Wishlist.remove(removeButton.getAttribute('data-wishlist-remove'));
      return;
    }

    var addButton = event.target.closest('[data-wishlist-add]');
    if (addButton) {
      if (addButton.disabled) return;
      var variantId = addButton.getAttribute('data-variant-id');
      if (!variantId) return;
      addToCart(variantId, addButton);
    }
  });

  document.addEventListener('wishlist:change', render);
  document.addEventListener('DOMContentLoaded', render);
  if (document.readyState !== 'loading') render();
})();
